<script>
/* COMPOSANTS */
import AkFormView from "@components/layout/AkFormView";
import AkInputText from "@components/input/AkInputText";
import BilanCircuit from "@views/bilan/circuit/components/BilanCircuit";

/* MIXINS */
import randomRef from "@mixins/randomRef";
import roleMixin from "@mixins/roleMixin";

/* SERVICES */
import bilanCircuitService from "@services/bilanCircuitService";
import circuitService from "@services/circuitService";

export default {
  components: {AkFormView, AkInputText, BilanCircuit},
  mixins: [randomRef, roleMixin],
  metaInfo() {
    return {
      title: "bilan.details"
    }
  },
  data() {
    return {
      loading: false,
      circuitList: [],
      current: {},
      currentGeneral: {},
      updated: false,
    }
  },
  mounted() {
    this.loading = true;
    this.getRef().showTotalLoader();
  
    let msg = this.$route.query.msg;
    if (msg && msg !== "") {
      this.getRef().success(msg);
      this.updated = true;
    }

    let p1 = bilanCircuitService.findByCeiId(this.ceiId);
    p1.then(data => this.current = data);
  
    let p2 = circuitService.findByCeiId(this.ceiId);
    p2.then(data => this.circuitList = data);

    Promise.all([p1, p2]).then(()=>{
      this.initData();
      this.getRef().hideLoader();
    });
  },
  methods: {
    initData() {
      this.currentGeneral.ager = this.circuitList[0].agerLabel;
      this.currentGeneral.uer = this.circuitList[0].uerLabel;
      this.currentGeneral.cei = this.circuitList[0].ceiLabel;
      this.currentGeneral.ceiId = this.ceiId;
      this.currentGeneral.yearDisplay = this.yearDisplay;
      
      // retirer les current qui ont une valeur dans year (ce sont les anciennes données qui sont archivées) -> et quand on affiche les données archivées ?
      //this.current = this.current.filter(c => c.year === null);
      
      // patch pour essayer de faire en sorte que ça fonctionne...
      
      let currentWithNullYear = this.current.filter(c => c.year === null);
      let currentWithTargetYear = this.current.filter(c => c.year === this.year);
      this.current = currentWithTargetYear.length>0 ? currentWithTargetYear : currentWithNullYear;
      
      if(this.current.length>0) {
        this.currentGeneral.createdById = this.current[0].createdById;
        this.currentGeneral.author = this.current[0].author;
      
        for (const element of this.current) {
          for (const circuit of this.circuitList) {
            if (element.circuitId === circuit.id) {
              element.number = circuit.number;
              element.axis = circuit.axis;
            }
          }
        }
        
        this.current.sort((a,b) => a.number >= b.number ? 1 : -1);
      }
      this.loading = false;
    },
    goToSynthese() {
      this.$router.push({name: "bilanCircuitSynthese"});
    }
  },
  computed: {
    ceiId() {
      return this.$route.params.id;
    },
    year() {
      return parseInt(this.$route.params.year);
    },
    yearDisplay() {
      return this.year + ' - ' + (this.year + 1);
    },
    agerLabel() {
      if(!this.circuitList) return '';
      if(this.circuitList.length===0) return '';
      return this.circuitList[0].agerLabel;
    },
    uerLabel() {
      if(!this.circuitList) return '';
      if(this.circuitList.length===0) return '';
      return this.circuitList[0].uerLabel;
    },
    ceiLabel() {
      if(!this.circuitList) return '';
      if(this.circuitList.length===0) return '';
      return this.circuitList[0].ceiLabel;
    },
  },
}
</script>

<template v-if=!roleLoading>
  <AkFormView :ref="ref" :title="$t('bilan.details')">
    <template v-slot:header>
      <button style="margin-right: 5px;" class="btn btn-inverse-primary" @click="goToSynthese()">
        {{ $t('goto_table') }}
      </button>
    </template>
    <template v-slot:action>
      <RouterLink v-if="currentGeneral.ceiId !== undefined && this.canEditCircuit() && !currentGeneral.year && this.canEditOrDeleteReview(currentGeneral)"
                  :to="{ name: 'bilanCircuitUpdate', params: {id: currentGeneral.ceiId}}"
                  class="btn btn-inverse-primary btn-xs">
        <i class="fe fe-edit pr-1"/>{{ $t('update') }}
      </RouterLink>
    </template>
    <template v-slot:form>
      <div class="form-row" v-if="currentGeneral.createdById !== null">
        <AkInputText :disabled=true v-model=currentGeneral.author class-name="col-md-4" :label="$t('bilan.author')"/>
      </div>
      <div class="form-row">
        <AkInputText
          :disabled=true
          v-model=currentGeneral.ager
          class-name="col-md-3"
          :label="$t('ager_label')"/>
        <AkInputText
          :disabled=true
          v-model=currentGeneral.uer
          class-name="col-md-3"
          :label="$t('uer_label')"/>
        <AkInputText
          :disabled=true
          v-model=currentGeneral.cei
          class-name="col-md-3"
          :label="$t('cei_label')"/>
        <AkInputText
          :disabled=true
          v-model=currentGeneral.yearDisplay
          class-name="col-md-3"
          :label="$t('year')"/>
      </div>
      <div class="mt-2 row">
        <BilanCircuit v-for="(row, index) in current" :key="index" :row="row" :index="index" ref="panels" :disabled="true"/>
      </div>
    </template>
  </AkFormView>
</template>